<template>
  <div class="header">
    <h1 class="title">
      Xbed
    </h1>
  </div>
</template>

<script>
export default {

}
</script>




// WEBPACK FOOTER //
// src/components/header.vue